<template>
  <div class="ehs-data-table-toolbar">
    <Toolbar>
      <slot>
        <span v-if="!!this.totalSelected" class="text-primary-500 font-medium">
          {{
            $tc('wizer.components.data-table-toolbar.items-selected', totalSelected, [
              totalSelected,
            ])
          }}
        </span>
      </slot>
      <template v-if="!!this.totalSelected" #selection-actions>
        <slot name="selection-actions" />
      </template>
      <template #actions>
        <slot name="actions" />
      </template>
    </Toolbar>
  </div>
</template>

<script>
import Toolbar from '@wizer/core/components/toolbar/Toolbar'

export default {
  name: 'EHSTableToolbar',
  components: {
    Toolbar,
  },
  props: {
    totalSelected: Number,
  },
}
</script>

<style scoped>
.ehs-data-table-toolbar {
  @apply flex flex-shrink-0 relative overflow-hidden;
  @apply rounded-tl rounded-tr;
}
</style>
